import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import ContactForm from './components/ContactForm/ContactForm';
import styles from './Contact.module.scss';

const Contact = () => {
  const { t } = useTranslation('contact');

  return (
    <section className={styles.contact}>
      <header>
        <div>
          <h3>{t('title')}</h3>
          <p>{t('subtitle')}</p>
        </div>
        <div />
      </header>
      <div className={styles.content}>
        <div>
          <ContactForm />
        </div>
        <div className={styles.phoneLines}>
          <h3>{t('phoneLines.title')}</h3>

          <a target="_blank" rel="noreferrer" href="https://wa.me/+59891890404">
            <FontAwesomeIcon
              icon={faWhatsapp as IconProp}
              className={styles.icon}
            />
            <div>
              <p className={styles.mediumFont}>(+598) 9189 0404</p>
              <p className={styles.smallFont}>
                {t('phoneLines.automatedAttention')}
              </p>
            </div>
          </a>
        </div>
        <div className={styles.attentionSchedule}>
          <h3>{t('attentionSchedule.title')}</h3>
          <div>
            <h4>{t('attentionSchedule.operationsTitle')}</h4>
            <p>{t('attentionSchedule.operationsText')}</p>
          </div>
          <div>
            <h4>{t('attentionSchedule.paymentsTitle')}</h4>
            <p>{t('attentionSchedule.paymentsText')}</p>
          </div>
          <div>
            <h4>{t('attentionSchedule.terminalTitle')}</h4>
            <p>{t('attentionSchedule.terminalText')}</p>
            <p>{t('attentionSchedule.terminalText2')}</p>
          </div>
          <div>
            <h4>{t('attentionSchedule.depo20Title')}</h4>
            <p>{t('attentionSchedule.depo20Text')}</p>
            <p>{t('attentionSchedule.depo20Text2')}</p>
            <p>{t('attentionSchedule.depo20Text3')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
